export interface DesignerUrlState {
  productSlug?: string;
  product?: string;
  productId?: string;
  parent?: string;
  parentId?: string;
  color?: string;
  qty?: number;
}

type QueryTarget = {
  params: URLSearchParams;
  write: (params: URLSearchParams) => string;
};

function getQueryTarget(url: URL): QueryTarget {
  const hash = url.hash || '';
  const questionIndex = hash.indexOf('?');

  if (questionIndex >= 0) {
    const hashPath = hash.slice(0, questionIndex);
    const hashQuery = hash.slice(questionIndex + 1);

    return {
      params: new URLSearchParams(hashQuery),
      write: (params) => {
        const query = params.toString();
        url.hash = query ? `${hashPath}?${query}` : hashPath;
        return url.toString();
      },
    };
  }

  return {
    params: new URLSearchParams(url.search),
    write: (params) => {
      const query = params.toString();
      url.search = query ? `?${query}` : '';
      return url.toString();
    },
  };
}

export function normalizeColorParam(color: string | undefined | null): string | undefined {
  const normalized = String(color ?? '')
    .replace(/^#/, '')
    .replace(/;/g, '')
    .trim();

  return normalized || undefined;
}

export function replaceDesignerUrlState(state: DesignerUrlState): void {
  const url = new URL(window.location.href);
  const target = getQueryTarget(url);
  const params = target.params;

  const setIfPresent = (key: string, value: string | number | undefined) => {
    if (value === undefined || value === '') return;
    params.set(key, String(value));
  };

  setIfPresent('product_slug', state.productSlug);
  setIfPresent('product', state.product);
  setIfPresent('product_id', state.productId);
  setIfPresent('parent', state.parent);
  setIfPresent('parent_id', state.parentId);
  setIfPresent('color', normalizeColorParam(state.color));
  setIfPresent('qty', state.qty);

  window.history.replaceState(window.history.state, '', target.write(params));
}
